// src/components/topToolBar/topToolBar.js
import React from "react";
import { Button, Input, Tag } from "antd";
import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import ExcelDownloadButton from "../excelDownload/excelDownloadButton";
import "../excelDownload/excelDownloadButton.css";
import "./topToolBar.css";

function TopToolBar({
  filtersConfig = {},
  searchPlaceholder = "Search...",
  onSearch,
  onFilterChange,
  onReset,
  extraButtons = [],
  // Excel download props
  excelData = null,
  excelFilename = "data-export",
  excelSheetName = "Sheet1",
  showExcelDownload = false,
  // CONTROLLED STATE PROPS
  searchTerm = "", // Now controlled by parent
  filters = {} // Now controlled by parent
}) {
  // Remove internal state management - everything comes from props now

  const handleFilterChange = (key, value) => {
    const updated = { ...filters, [key]: value };
    onFilterChange?.(updated);
  };

  const handleRemoveFilter = (key) => {
    const updated = { ...filters, [key]: null };
    onFilterChange?.(updated);
  };

  const handleReset = () => {
    onReset?.();
  };

  const handleSearchChange = (value) => {
    onSearch?.(value);
  };

  return (
    <div className="toolbar-container">
      <div className="toolbar-row">
        {/* Filter Dropdown */}
        <div className="filter-dropdown-container">
          <Button type="default" icon={<FilterOutlined />} className="filter-hover-btn">
            Filter By
          </Button>

          <div className="filter-dropdown">
            {Object.entries(filtersConfig).map(([key, config]) => (
              <div key={key} className="filter-option">
                <span>{config.label}</span>
                <div className="filter-submenu">
                  {config.options.map((opt) => (
                    <div key={opt.value} className="filter-suboption" onClick={() => handleFilterChange(key, opt.value)}>
                      {opt.label}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Reset Button */}
        <Button type="default" icon={<ReloadOutlined />} onClick={handleReset} className="filter-reset-btn">
          Reset
        </Button>

        {/* Search */}
        <div className="search-section">
          <Input
            placeholder={searchPlaceholder}
            value={searchTerm} // Now controlled by parent
            onChange={(e) => handleSearchChange(e.target.value)}
            className="search-input"
          />
        </div>

        {/* Excel Download Button */}
        {showExcelDownload && (
          <ExcelDownloadButton data={excelData || []} filename={excelFilename} sheetName={excelSheetName} variant="outline">
            Download
          </ExcelDownloadButton>
        )}

        {/* Extra Buttons */}
        {extraButtons.map((btn, i) => (
          <span key={i}>{btn}</span>
        ))}
      </div>

      {/* Active Filters Row */}
      <div className="active-filters-row">
        {Object.entries(filters)
          .filter(([_, val]) => val)
          .map(([key, val]) => {
            const config = filtersConfig[key];
            const label = config?.options.find((opt) => opt.value === val)?.label || val;
            return (
              <Tag key={key} closable onClose={() => handleRemoveFilter(key)} color="blue">
                {config?.label}: {label}
              </Tag>
            );
          })}
      </div>
    </div>
  );
}

export default TopToolBar;
